import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import Provider from './Store/Provider';
import reportWebVitals from './reportWebVitals';

// import AlertTemplate from 'react-alert-template-basic'
// import { transitions, positions, Provider as AlertProvider } from 'react-alert'

import { ToastContainer } from "react-toastify";
// import 'material-icons/iconfont/material-icons.css';



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Provider>
         {/* <AlertProvider template={AlertTemplate} {...options}> */}

            
            <App />
         {/* </AlertProvider> */}

         <ToastContainer />
    </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
